import { fail } from "./assert.js";
import { getScriptElement } from "./query.js";
export const parseDOM = (data, type) => new DOMParser().parseFromString(data, type);
export const parseJSON = (data) => JSON.parse(data);
export const parseHTML = (data) => parseDOM(data, "text/html");
export const parseSVG = (data) => parseDOM(data, "image/svg+xml");
export const parseScriptElementAsJson = (id) => {
    const script = getScriptElement(id);
    ASSERT: if (script.type !== "application/json") {
        fail(`parseScriptElementAsJson("${id}") has not the expected mime type "application/json"`, script);
    }
    return parseJSON(script.text);
};
